import { defineStore } from 'pinia';
import { traceService, type AppointmentVoucher, type AppointmentForm } from '../services/traceService';
import type { TraceChainDetail, BaseLandPoint } from '../mock/traceData';

export const useTraceStore = defineStore('trace', {
  state: () => ({
    currentCode: 'MA.156.A1.0058.AG.101/20260812.ORG.0010',
    traceData: null as TraceChainDetail | null,
    loading: false,
    selectedLand: null as BaseLandPoint | null,
    myVouchers: [] as AppointmentVoucher[],
    activeAnchor: 'overview',
  }),

  getters: {
    productName: (state) => state.traceData?.productInfo.productName || '',
    // 兜底不能写具体基地名：库里查不到时会把这个假名字显示给消费者
    baseName: (state) => state.traceData?.baseInfo.baseName || '',
    isLoaded: (state) => !!state.traceData,
  },

  actions: {
    async fetchTraceInfo(code?: string) {
      if (code) {
        this.currentCode = code;
      }
      this.loading = true;
      try {
        const data = await traceService.getTraceDetail(this.currentCode);
        this.traceData = data;
        if (data.nearbyLands && data.nearbyLands.length > 0) {
          this.selectedLand = data.nearbyLands[0] || null;
        }
      } catch (err) {
        console.error('Failed to load trace info:', err);
      } finally {
        this.loading = false;
      }
    },

    setSelectedLand(land: BaseLandPoint) {
      this.selectedLand = land;
    },

    async addAppointment(form: AppointmentForm) {
      const voucher = await traceService.submitAppointment(form);
      this.myVouchers.unshift(voucher);
      return voucher;
    },
  },
});
